import React, { memo } from "react";
import PropTypes from "prop-types";
import styles from "./SkillsGrid.module.css";
import skillsData from "./SkillsGridData";
import { SKILLS_CATEGORIES } from "../../config/constants";
import { handleImageError } from "../../utils/imageUtils";

const SkillsGrid = memo(() => {
  return (
    <section className="card" aria-label="Skills section">
      <div className={styles.SkillsGrid}>
        <h2 className={styles.heading}>Skills</h2>
        
        <div className={styles.categoryGrid}>
          {SKILLS_CATEGORIES.map((category) => (
            <div key={category} className={styles.categorySection}>
              <h3 className={styles.categoryTitle}>{category}</h3>
              <div className={styles.skillsContainer} role="list" aria-label={`${category} skills`}>
                {skillsData
                  .filter((skill) => skill.category === category)
                  .map((skill, index) => (
                    <div 
                      key={`${category}-${index}`} 
                      className={styles.skillTile}
                      role="listitem"
                    >
                      <img 
                        src={skill.src} 
                        alt={skill.alt} 
                        className={styles.skillImage}
                        onError={(e) => handleImageError(e)}
                        loading="lazy"
                      />
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

SkillsGrid.displayName = 'SkillsGrid';

SkillsGrid.propTypes = {};

export default SkillsGrid;
